import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Grid,
  Typography,
  Button,
  IconButton,
  Tooltip,
  Slide
} from "@mui/material";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddBoxIcon from "@mui/icons-material/AddBox";
import React from "react";
import { useWatch, type FieldValues, type UseFormReturn } from "react-hook-form";
import type {
  ArrayPath,
  FieldArrayWithId,
  UseFieldArrayAppend,
  UseFieldArrayRemove
} from "react-hook-form";
import CustomTextField from "../CustomTextField";
import { gridSizeMdLg10, gridSizeMdLg2, } from "@/shared";

type CustomEmailDialogProps<
  T extends FieldValues,
  K extends ArrayPath<T>
> = {
  title: string;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  message: string;
  form: UseFormReturn<T>;
  fieldName: K;
  fields: FieldArrayWithId<T, K>[];
  append: UseFieldArrayAppend<T, K>;
  remove: UseFieldArrayRemove;
  onEditChange?: (editable: boolean, index: number) => void;

  editableIndex: number | null;
  setEditableIndex: React.Dispatch<React.SetStateAction<number | null>>;
  onSave?: (emails: string[]) => void
};

const Transition = React.forwardRef(function Transition(
  props: any,
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function CustomEmailDialog<
  T extends FieldValues,
  K extends ArrayPath<T>
>({
  title,
  open,
  setOpen,
  message,
  form,
  fieldName,
  fields,
  append,
  remove,
  onEditChange,
  editableIndex,
  setEditableIndex,
  onSave
}: CustomEmailDialogProps<T, K>) {
  const {
    formState: { errors }
  } = form;

  const handleClose = () =>{
    // onSave?.([])
    setOpen(false)
  }
  const correoWatch = useWatch({
    control: form.control,
    name: fieldName as any
  });

  //  Editar campo automático
  const onEdit = (index: number) => {
    const isEditing = editableIndex === index;

    // Si estaba editando → termina edición
    if (isEditing) {
      setEditableIndex(null);
      onEditChange?.(false, index);
      return;
    }

    // Si no estaba editando → ahora sí
    setEditableIndex(index);
    onEditChange?.(true, index);
  };
  const handleSave = () => {
    const correos = form.getValues(fieldName as any) as any[];

    const listaEmails = correos
      .map(c => c.name?.trim())
      .filter(email => email && email !== "");
    onSave?.(listaEmails); // envía al padre
    setOpen(false);
  }

  /*  const onEdit = (index: number) => {
     const path = `${fieldName}.${index}.isEditable` as any;
 
     const current = form.getValues(path);
     const updated = !current;
 
     form.setValue(path, updated as any, {
       shouldDirty: true,
       shouldTouch: true
     });
 
     onEditChange?.(updated, index);
   }; */

  return (
    <Dialog open={open} onClose={handleClose} TransitionComponent={Transition}>
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        <Grid container spacing={3} justifyContent={'space-between'}>

          <Grid item xs={12}>
            <DialogContentText sx={{ fontWeight: 600, fontSize: '1rem'}}>{message}</DialogContentText>
          </Grid>

          <Grid item xs={8}>
            <Typography variant="subtitle2"  >Ingresar correo</Typography>
          </Grid>

          <Grid item>
            <Button
              size="small"
              color="inherit"
              variant="text"
              endIcon={<AddBoxIcon />}
              onClick={() =>
                append({
                  name: "",
                  isEditable: true,
                  isAutomatic: false
                } as any)
              }
            >
              Agregar
            </Button>
          </Grid>

          {/* Lista de correos */}
          {fields.map((field, index) => {
            // AHORA SÍ: esto observa cambios reales
            const correo = correoWatch?.[index] ?? {}

            //const isEditable = correo?.isEditable ?? false;
            const isAutomatic = correo?.isAutomatic ?? false;

            const itemErrors = (errors as any)?.[fieldName]?.[index];

            return (
              <Grid
                key={field.id}
                container item spacing={1}

              >
                {/* Campo correo */}
                <CustomTextField
                  name={`${fieldName}.${index}.name`}
                  label={`Correo ${index + 1}`}
                  control={form.control}
                  defaultValue={correo?.name}
                  type="email"
                  //disabled={!isEditable} // 
                  disabled={isAutomatic ? editableIndex !== index : false}
                  //disabled={editableIndex !==index}
                  error={itemErrors?.name}
                  helperText={itemErrors?.name?.message}
                  size={gridSizeMdLg10}
                />
                <Grid item {...gridSizeMdLg2}>
                  {isAutomatic && (
                    <Tooltip title="Editar">
                      <IconButton onClick={() => onEdit(index)}>
                        <ModeEditIcon
                          color={editableIndex === index ? "info" : "disabled"}
                        />
                      </IconButton>
                    </Tooltip>
                  )}
                  <Tooltip title="Eliminar">
                    <IconButton onClick={() => remove(index)}>
                      <DeleteIcon color="error" />
                    </IconButton>
                  </Tooltip>

                </Grid>

              </Grid>
            );
          })}
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button onClick={handleSave}>Confirmar</Button>
      </DialogActions>
    </Dialog>
  );
}
